<template>
  <v-card>
        <v-form
          ref="formAddGate"
          v-model="valid"
          lazy-validation
        >
          <v-card-text>
          <v-row>
            <v-col cols="12" sm="5">
              <v-combobox
                v-model="formDoorphone.address"
                @keyup="startTypingTimer"
                :rules="rules.required"
                :items="addresses"
                item-text="addresses"
                prepend-inner-icon="mdi-rename-box-outline"
                :search-input.sync="searchAddress"
                return-object
                flat
                label="Адрес"
                outlined
                dense
              ></v-combobox>

              <v-autocomplete
                label="Район (только для г. Саранск)"
                :items="district"
                :item-text="item => (item.name) + ' (' + displayCity(item.city_id) + ')'"
                item-value="id"
                v-model='region'
                prepend-inner-icon="mdi-map-marker-radius-outline"
                type="string"
                outlined
                :disabled="!isDistrict"
                dense
                flat
                clearable
              />

              <v-select
                label="Оплата мобильного приложения"
                :items="paymentTypes"
                v-model='paymentType'
                item-text="payment_type"
                prepend-inner-icon="mdi-credit-card-outline"
                item-value="id"
                outlined
                dense
                flat
                required
              ></v-select>

              <v-autocomplete
                label="Управляющая компания"
                :items="managementCompanies"
                item-text="name"
                item-value="id"
                @change="setGroupManagement"
                prepend-inner-icon="mdi-home-account"
                v-model='formDoorphone.managementCompany'
                type="string"
                outlined
                dense
                flat
                clearable
              />
              <v-text-field
                label="Компания-собственник"
                v-model='formDoorphone.groupManagement'
                prepend-inner-icon="mdi-shield-account"
                type="string"
                outlined
                dense
                flat
                disabled
              ></v-text-field>
              <v-checkbox
                v-model="formDoorphone.isWithoutPrefix"
                hide-details
                :disabled="isPrefix"
                dense
                color="success"
                label="Добавить без префикса"
                class="checkbox mb-2"
              ></v-checkbox>
              <v-card-text class="mb-5 pt-1" v-if="isPrefix">
                Удалите все домофоны из списка, что бы изменить настройки префикса.
              </v-card-text>
              <v-btn
                @click="popupBindDoorphones = true"
                class="ml-2"
                color="#1E6CEB"
                dark
              >
                Привязать домофон
              </v-btn>
              <h2 class="ma-3">{{ doorphoneText }}</h2>
              <v-data-table
                class="table"
                :headers="headersDoorphones"
                :items="selectedDoorphones"
                v-if ="selectedDoorphones.length > 0"
                :disable-sort="true"
                hide-default-footer
              >
                <template v-slot:item.address="{ item }">
                  {{ item.address }}
                </template>
                <template v-slot:item.apartment_prefix="{ item }">
                  {{ item.apartment_prefix }}
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-row justify="center" class="flex-nowrap">
                    <v-btn
                      icon
                      text
                      small
                      class="btn__icon pa-0"
                      width="18"
                      height="18"
                      @click.prevent="deleteDoorphone(item)"
                    >
                      <v-icon size="large">mdi-close</v-icon>
                    </v-btn>
                  </v-row>
                </template>
              </v-data-table>
            </v-col>
            <v-col class="pb-0">
              <v-card>
                <v-card-title>
                  <span>Устройства</span>
                  <v-col>
                  <v-text-field
                    v-model="searchDevice"
                    label="Поиск по IP адресу"
                    dense
                    autocomplete="chrome-off"
                    hide-details
                    @keyup="(e) => e.keyCode === 13 && filterDevices()"
                  ></v-text-field>
                  </v-col>
                  <v-btn
                    dark
                    class="btn blue darken-3 white px-7 text-none"
                    @click.prevent="filterDevices"
                  >
                    Поиск
                  </v-btn>
                </v-card-title>
                <v-data-table
                  class="table"
                  v-model="selectedDevices"
                  :options.sync="universalOptions"
                  :server-items-length="universalTotalDevices"
                  :headers="headersDevices"
                  :items="devices"
                  item-key="id"
                  show-select
                  :footer-props="{
                    'items-per-page-options': [10, 20, 50, 100],
                  }"
                  :single-select="true"
                  :disable-sort="true"
                >
                </v-data-table>
              </v-card>
              <v-col cols="12" v-if="errorDevice">
                <v-alert
                  type="error"
                  dense
                  outlined
                >
                  Выберите устройство
                </v-alert>
              </v-col>
            </v-col>
          </v-row>
        </v-card-text>
          <v-card-actions class="ml-3">
            <div class="my-2">
              <v-btn
                large
                color="success"
                class="text-none"
                dark
                @click="validate()"
              >
                Сохранить
              </v-btn>
              <v-btn
                large
                class="ma-2 text-none"
                outlined
                dense
                hide-details
                color="error"
                @click.prevent="returnDoorphones()"
              >
                Отменить
              </v-btn>
            </div>
          </v-card-actions>
        </v-form>

    <v-dialog v-model="popupApartmentPrefix" persistent max-width="380">
      <v-card>
        <v-card-title>Установите префикс для квартир</v-card-title>
        <v-col>
          <v-text-field
            label="префикс для квартир"
            v-model.number="apartmentPrefix"
            :rules="[
                v => !!v || 'Обязательное поле',
                v => v >= 0 || 'Введите целое число',
            ]"
            type="number"
            outlined
            dense
            flat
            required
            autofocus
          ></v-text-field>
        </v-col>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            text
            @click.prevent="addPrefix(apartmentPrefix)"
            :disabled="apartmentPrefix === ''"
          >
            добавить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="popupBindDoorphones" max-width="600" lazy-validation>
      <v-card class='pb-5'>
        <v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>
        <v-card-title class="headline">
          Привязать домофон
          <v-spacer></v-spacer>
          <v-btn
            icon
            text
            x-large
            class="btn__icon pa-0"
            width="18"
            height="18"
            @click="BackTypeDoorphone()"
          >
            <v-icon size="x-large">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-row class="mx-6 mt-2">
          <v-text-field
            v-model='filterAddress'
            class="mr-2"
            placeholder="Поиск по адресу"
            solo
            outlined
            dense
            hide-details
            flat
          ></v-text-field>
          <v-text-field
            v-model='filterId'
            placeholder="Поиск по id"
            solo
            outlined
            dense
            hide-details
            flat
          ></v-text-field>
          <div class="mb-2">
            <v-btn
              dark
              class="btn blue darken-3 white px-7 text-none mt-4 mb-4"
              @click.prevent="filterDoorphones"
            >
              Поиск
            </v-btn>
          </div>
        </v-row>
        <v-data-table
          class="table mx-5 pb-5"
          :options.sync="options"
          :server-items-length="totalDoorphones"
          :items="searchFreeDoorphones"
          :headers="headersTieDoorphones"
          :footer-props="{
            'items-per-page-options': [10, 20, 50, 100],
          }"
        >
          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  text
                  x-large
                  class="btn__icon pa-0"
                  width="18"
                  height="18"
                  @click.prevent="addDoorphone(item)"
                >
                  <v-icon color="blue">mdi-plus-circle</v-icon>
                </v-btn>
              </template>
              <span>Привязать домофон</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>

  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { headersDevices } from '../EditDoorphone/consts';
import watchTableOptions from '../../../mixins/watchTableOptions';

export default {
  name: 'NewGate',
  mixins: [watchTableOptions],
  data () {
    return {
      valid: true,
      searchDevice: '',
      doorphones: [],
      selectedDoorphones: [],
      doorphonesArray: [],
      options: {
        sortBy: [],
        sortDesc: [],
        page: 1,
        itemsPerPage: 10,
      },
      filters: { type: 'M', manufacturer: 'Rubetek' },
      totalDoorphones: 0,
      isCreated: false,
      isFirstLoading: false,
      loading: true,
      searchAddress: '',
      popupBindDoorphones: false,
      isDistrict: false,
      popupApartmentPrefix: false,
      region: null,
      value: '',
      filterAddress: '',
      filterId: '',
      paymentType: 'G',
      universalTotalDevices: 0,
      typingTimer: null,
      universalOptions: {
        itemsPerPage: 10,
        page: 1,
        sortBy: [],
        sortDesc: [],
      },
      paymentTypes: [
        {
          id: 'G',
          payment_type: 'Калитка',
        },
      ],
      headersDevices,
      selectedDevices: [],
      isPrefix: false,
      errorDevice: false,
      apartment_prefix: [],
      apartmentPrefix: '',
      formDoorphone: {
        managementCompany: '',
        groupManagement: '',
        isWithoutPrefix: false,
      },
      rules: {
        required: [
          v => !!v || 'Поле обязательно для заполнения',
        ],
        requiredNumber: [
          v => !!v || 'Поле обязательно для заполнения',
          v => v >= 0 || 'Введите целое число',
        ],
      },
      headersDoorphones: [
        { text: 'id', value: 'id' },
        { text: 'Адрес', value: 'address' },
        { text: 'Префикс', value: 'apartment_prefix' },
        { text: '', value: 'actions' },
      ],
      headersTieDoorphones: [
        { text: 'id', value: 'id' },
        { text: 'Адрес', value: 'address' },
        { text: '', value: 'actions' },
      ],
      searchCity: '',
      searchStreet: '',
    };
  },
  computed: {
    ...mapGetters({
      devices: 'Device/devices',
      addresses: 'Doorphone/addresses',
      doorphone: 'Doorphone/doorphoneExpanded',
      doorphonesArrays: 'Doorphone/doorphonesExpanded',
      district: 'Doorphone/districts',
      managementCompanies: 'ManagementCompany/managementCompanies',
    }),
    filteredFreeDoorphones () {
      if (this.doorphones) {
        return this.doorphonesArrays.filter(item => {
          return this.doorphones.indexOf(item) === -1;
        });
      }

      return [];
    },
    searchFreeDoorphones () {
      if (this.serchValue) {
        return this.filteredFreeDoorphones.filter(item => {
          return item.address.toString().toLowerCase().includes(this.serchValue.toLowerCase());
        });
      }

      if (this.serchValueId) {
        return this.filteredFreeDoorphones.filter(item => {
          return item.id.toString().toLowerCase().includes(this.serchValueId.toLowerCase());
        });
      }
      return this.filteredFreeDoorphones;
    },
    doorphoneText () {
      if (this.selectedDoorphones.length > 1) {
        return 'Домофоны';
      }
      if (this.selectedDoorphones.length === 1) {
        return 'Домофон';
      }
      return '';
    },
  },
  watch: {
    universalOptions (curr, prev) {
      this.handleOptionsChange(curr, prev, () => {
        this.universalChangePage();
      });
    },
    options: {
      handler () {
        if (!this.isCreated) {
          this.updateSort();
          this.loadDoorphones();
        } else {
          this.isCreated = false;
        }
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions({
      loadDevices: 'Device/getDevices',
      loadCities: 'Doorphone/getCities',
      loadStreets: 'Doorphone/getStreets',
      newGate: 'Gate/newGate',
      getDoorphones: 'Doorphone/getExpandedDoorphones',
      getAddressSearch: 'Doorphone/getAddressSearch',
    }),
    validateKeyUp (e) {
      if (e.keyCode === 13) {
        this.filterDoorphones();
      }
    },
    startTypingTimer (val) {
      clearTimeout(this.typingTimer);
      this.typingTimer = setTimeout(() => {
        if (!this.isFirstLoading && val.srcElement._value) {
          this.getAddressSearch({
            value: val.srcElement._value,
          })
            .then((res) => {
              this.region = null;
              this.isDistrict = !!res.districts[0];
            });
        }
      }, 600);
    },
    displayCity (item) {
      switch (item) {
        case 1: return 'Ульяновск';
        case 2: return 'Саранск';
        default: return '';
      }
    },
    setGroupManagement (groupCompanyId) {
      const company = this.managementCompanies.find(item => item?.id === groupCompanyId);
      if (company) {
        const management = company.management_group;
        this.formDoorphone.groupManagement = management?.name ?? 'Нет группы';
      } else {
        this.formDoorphone.groupManagement = '';
      }
    },
    filterDevices () {
      this.universalOptions.page = 1;
      this.universalChangePage();
    },
    universalChangePage () {
      const filters = { free: 1 };
      filters['model.manufacturer.name'] = 'Rubetek';

      if (this.searchDevice) {
        filters.ip_address = this.searchDevice;
      }

      this.loadDevices({
        pagination: 1,
        limit: this.universalOptions.itemsPerPage,
        page: this.universalOptions.page,
        filters,
      })
        .then((response) => {
          this.universalTotalDevices = response.meta.total;
        });
    },
    BackTypeDoorphone () {
      this.popupBindDoorphones = false;
    },
    addPrefix (apartmentPrefix) {
      const doorphone = this.doorphones[this.doorphones.length - 1];
      this.isPrefix = true;

      this.selectedDoorphones.push({
        id: doorphone.id,
        address: doorphone.address,
        apartment_prefix: apartmentPrefix,
      });
      this.cancelBindDoorphone();
    },
    async addDoorphone (doorphone) {
      this.doorphones.push(doorphone);
      this.apartmentPrefix = doorphone.apartmentPrefix;
      if (!this.formDoorphone.isWithoutPrefix) {
        this.popupApartmentPrefix = true;
      } else {
        await this.addPrefix();
      }
    },
    getDoorphoneAddress (doorphone) {
      let address = doorphone.address;
      if (doorphone.entrance > 0) {
        address = `${doorphone.address}, п.${doorphone.entrance}`;
      }
      return address;
    },
    deleteDoorphone (item) {
      this.selectedDoorphones = this.selectedDoorphones.filter(doorphone => doorphone.id !== item.id);
      if (this.selectedDoorphones === null || this.selectedDoorphones.length < 1) {
        this.isPrefix = false;
      }
    },
    cancelBindDoorphone () {
      this.confirm = false;
      this.popupBindDoorphones = false;
      this.popupApartmentPrefix = false;
      this.value = '';
      this.serchValue = '';
      this.serchValueId = '';
    },
    validate () {
      this.errorDevice = false;
      let tempDevice;
      let doorphonesGate;
      if (this.selectedDoorphones === null || this.selectedDoorphones.length < 1) {
        this.$flash_danger('Привяжите домофон');
        return;
      } else {
        doorphonesGate = this.selectedDoorphones.map(doorphone => doorphone.id);
      }
      if (!this.selectedDevices.length) {
        this.$flash_danger('Заполните все поля');
        this.errorDevice = true;
        this.$refs.formAddGate.validate();
        return;
      } else {
        tempDevice = this.selectedDevices[0].id;
      }

      if (this.$refs.formAddGate.validate()) {
        const tempDoorphone = {
          device_id: tempDevice,
          doorphones: doorphonesGate,
          payment_type: this.paymentType,
          address: this.formDoorphone.address,
          without_apartment_prefix: this.formDoorphone.isWithoutPrefix,
        };
        tempDoorphone.payment_type = this.paymentType;

        if (this.region && this.isDistrict) {
          tempDoorphone.region_id = this.region;
        }
        const apartmentPrefixes = this.selectedDoorphones
          .map(doorphone => doorphone.apartment_prefix);

        if (apartmentPrefixes.some(prefix => prefix !== undefined)) {
          tempDoorphone.apartment_prefix = this.selectedDoorphones.map(doorphone => doorphone.apartment_prefix);
        }

        if (this.formDoorphone.managementCompany) {
          tempDoorphone.management_company_id = this.formDoorphone.managementCompany;
        }

        if (this.region === null && this.isDistrict) {
          this.$flash_danger('Заполните поле "Район"');
        } else {
          this.newGate(tempDoorphone)
            .then(() => {
              this.$router.push({ name: 'Doorphone' });
              this.$flash_success('Калитка успешно создана');
            })
            .catch((err) => {
              console.error(err);
              if (err.response && err.response.status === 422) {
                const error = err.response.data.device_id;
                error.forEach(item => {
                  this.$flash_danger('Ошибка: ' + item);
                });
              } else {
                this.$flash_warning('Ошибка при добавлении калитки');
              }
            });
        }
      } else {
        this.$flash_danger('Заполните все поля');
      }
    },
    returnDoorphones () {
      this.$router.push({ name: 'Doorphone' });
    },
    filterDoorphones () {
      this.options.page = 1;
      this.filters = { type: 'M', manufacturer: 'Rubetek' };

      if (this.filterAddress) {
        this.filters.address = this.filterAddress;
      }
      if (this.filterId) {
        this.filters.id = this.filterId;
      }
      this.$router.push({
        query: {
          address: this.filters.address,
        },
      }).catch(() => {});
      this.loadDoorphones();
    },
    updateSort () {
      if (this.options.sortBy.length > 0) {
        if ((this.options.sortDesc.length > 0) && (this.options.sortDesc[0])) {
          this.sort = '-' + this.options.sortBy[0];
        } else {
          this.sort = this.options.sortBy[0];
        }
      } else {
        this.sort = '';
      }
    },
    loadDoorphones () {
      this.getDoorphones({
        pagination: 1,
        page: this.options.page,
        limit: this.options.itemsPerPage,
        sort: this.sort,
        filters: this.filters,
      })
        .then((data) => {
          this.loading = false;
          this.totalDoorphones = data.meta.total;
          data.doorphones.forEach((doorphone) => {
            doorphone.apartmentPrefix = doorphone.address.split(', д.').pop().replace(/\D+/g, '');
          });
          this.doorphonesArray = data.doorphones;
        });
    },
  },
  created () {
    const filters = { free: 1 };
    filters['model.manufacturer.name'] = 'Rubetek';
    this.loadDevices({
      filters,
      pagination: 1,
      limit: this.universalOptions.itemsPerPage,
    })
      .then((response) => {
        this.universalTotalDevices = response.meta.total;
      });
  },
};
</script>

<style lang="scss">
</style>
